import Vue from 'vue';
import Vuex from 'vuex';
import config from '../../vue.config';
// import axios from 'axios'
import Api from '../services/Api';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userData: {},
    userId: '',
    isAuthenticated: false,
    token: '',
    error: null,
    allBusinesses: [],
    allAgencies: [],
    allApplicants: [],
    allApplications: [],
    myPosts: [],
    allPosts: []
  },
  // End of State

  // Start of Mutations
  mutations: {
    initializeStore(state) {
      if (localStorage.getItem('userId')) {
        state.userId = localStorage.getItem('userId');

      } else {
        // localStorage.setItem('userId',JSON.stringify(state.userId))
        state.userId = '';
      }
      if (localStorage.getItem('token')) {
        state.token = localStorage.getItem('token');
        state.isAuthenticated = true;
      } else {
        state.token = '';
        state.isAuthenticated = false;
      }

      if (localStorage.getItem('isAuthenticated')) {
        state.isAuthenticated = localStorage.getItem('isAuthenticated');
      } else {
        state.isAuthenticated = false;
      }
    },
    storeUserData: (state, payload) => {
      state.userData = payload;
    },
    storeUserId: (state, payload) => {
      state.userId = payload;
    },
    storeError: (state, payload) => {
      state.error = payload;
    },
    toggleLogin: (state, payload) => {
      state.isAuthenticated = payload;
    },
    allBusinesses: (state, payload) => {
      state.allBusinesses = payload.data;
    },
    allAgencies: (state, payload) => {
      state.allAgencies = payload.data;
    },
    allApplicants: (state, payload) => {
      state.allApplicants = payload.data;
    },
    allApplications: (state, payload) => {
      state.allApplications = payload;
    },
    updatedUserData: (state, payload) => {
      state.userData = payload;
    },
    myPosts: (state, payload) => {
      state.myPosts = payload;
    },
    allPosts: (state, payload) => {
      state.allPosts = payload;
    },
    updateUserList: (state, payload) => {
      if(payload.user.userType === 'business') {
        let userObjectIndex = allBusiness.findIndex(
          (user) => user.id === payload.user.id
        );
        if (userObjectIndex !== -1) {
          state.allBusiness[userObjectIndex] = payload.user;
        }
      }else if(payload.user.userType === 'normal-user') {
        let userObjectIndex = allApplicants.findIndex(
          (user) => user.id === payload.user.id
        );
        if (userObjectIndex !== -1) {
          state.allApplicants[userObjectIndex] = payload.user;
        }
      } else {
        let userObjectIndex = allAgencies.findIndex(
          (user) => user.id === payload.user.id
        );
        if (userObjectIndex !== -1) {
          state.allAgencies[userObjectIndex] = payload.user;
        }
      }
    },
    updateMyApplications: (state, payload) => {
      state.userData.myApplications.push(payload.application);
    }
  },
  // End of Mutations

  // Start of Actions
  actions: {
    async login(context, loginDetails) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/login`;

      await Api().
        post(endpoint, loginDetails)
        .then((res) => {
          response = res.data;

          localStorage.setItem('token', response.token);
          context.commit('storeUserData', response.data);
          context.commit('storeUserId', response.data.id);

          localStorage.setItem('userId', response.data.id);
          localStorage.setItem('accountType', response.data.userType);

          context.commit('toggleLogin', true);
          localStorage.setItem('isAuthenticated', true);
        })
        .catch((err) => {
          if (err.response === undefined) {
            error = err;
          } else {
            error = err.response.data;
          }
        });

      return { response, error };

    },
    async fetchUserData(context) {
      // let response, error;
      const endpoint = `${config.devServer.proxy}/user/view/${localStorage.getItem('userId')}`;

      await Api().
        get(endpoint)
        .then((res) => {
          context.commit('storeUserData', res.data.data);
          context.commit('storeError', null);
        })
        .catch(err => {
          if (err.response === undefined) {
            context.commit('storeError', err);
          } else {
            context.commit('storeError', err.response.data.error);
          }
        });

    },
    async userSignup(context, data) {

      let response; let error;
      let endpoint;

      data.userType ?
      endpoint = `${config.devServer.proxy}/user/signup`
      : endpoint = `${config.devServer.proxy}/agency/signup`;

      await Api().
        post(endpoint, { ...data })
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          if (err.response === undefined) {
            error = err;
          } else {
            error = err.response.data;
          }
        });

      return { response, error };

    },
    async forgotPassword(context, data) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/forgot-password`;

      await Api().
        post(endpoint, { ...data })
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          if (err.response === undefined) {
            error = err;
          } else {
            error = err.response.data;
          }
        });

      return { response, error };

    },
    async resetPassword(context, data) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/reset-password`;

      await Api().
        post(endpoint, data)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          if (err.response === undefined) {
            error = err;
          } else {
            error = err.response.data;
          }
        });

      return { response, error };

    },
    async getAllPosts(context) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/job/all`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data.data;
          context.commit('allPosts', res.data.data);
        })
        .catch((err) => {
          if (err.response === undefined) {
            error = err;

          } else {
            error = err.response.data;
          }
        });

      return { response, error };

    },
    async getMyPosts(context) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/job/my-jobs`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('myPosts', res.data.data);
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };
    },
    async fetchJob(context, data) {
      let response; let error;

      const endpoint = `${config.devServer.proxy}/job/${data}`;
      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async deleteJob(context, jobId) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/job/delete/${jobId}`;

      await Api().
        delete(endpoint)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async postJob(context, data) {
      let jobData = data[0];
      let imageData = data[1];

      let response; let error; let imageUploadStatus;

      const endpoint = `${config.devServer.proxy}/job/create`;
      const uploadImageEndpoint = `${config.devServer.proxy}/job/upload/job-cover-photo`;

      const fd = new FormData;

      // Check if image exist and upload document
      if(imageData) {
        fd.append('job-file', imageData, imageData.name);

        await Api().post(uploadImageEndpoint, fd)
        .then((res) => {
          jobData['jobCoverPhotoUrl'] = res.data.jobCoverPhotoUrl;
          imageUploadStatus = 'success';
        })
        .catch((err) => {
          error = err.response.data.error.message;
          imageUploadStatus = 'failed';

          // End job cover photo upload action and return error message
          return error;
        });

      }

      // Post Job to Database if
      if (jobData && imageUploadStatus !== 'failed') {
        await Api().
          post(endpoint, { ...jobData })
          .then((res) => {
            response = res.data;
          })
          .catch((err) => {
            error = err.response.data;
          });
      }

      return { response, error };

    },
    async updateJob(context, data) {
      let job = data;
      let jobId = job.id;

      let response; let error;

      const endpoint = `${config.devServer.proxy}/job/edit/${jobId}`;
      const uploadImageEndpoint = `${config.devServer.proxy}/job/upload/job-cover-photo`;

      if (job.isCoverPhotoChanged === true) {
        let imageData = job.jobCoverPhotoUrl;

        const fd = new FormData;
        fd.append('job-file', imageData, imageData.name);

        await Api().post(uploadImageEndpoint, fd)
          .then((res) => {
            job.jobCoverPhotoUrl = res.data.jobCoverPhotoUrl;
          })
          .catch((err) => {
            error = err.response.data;
          });
      } else if (!job.jobCoverPhotoUrl || job.jobCoverPhotoUrl === null) {
        job.jobCoverPhotoUrl = null;
      }

      await Api().
        patch(endpoint, { ...job })
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async deleteUser(context, userId) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/delete?userId=${userId}`;

      await Api().
        delete(endpoint)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async disableUser(context, userId) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/disable?userId=${userId}`;

      await Api().
        patch(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('updateUserList', res.data);
        })
        .catch((err) => {
          error = err;
        });

      return { response, error };

    },
    async enableUser(context, userId) {

      let response; let error;
      const endpoint = `${config.devServer.proxy}/user/enable?userId=${userId}`;

      await Api().
        patch(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('updateUserList', res.data);
        })
        .catch((err) => {
          error = err;
        });

      return { response, error };

    },
    async getAllBusinesses(context) {

      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/businesses`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('allBusinesses', res.data);
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async getAllAgencies(context) {

      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/agencies`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('allAgencies', res.data);
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async getAllApplicants(context) {

      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/applicants`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
          context.commit('allApplicants', res.data);
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async getApplication(context, id) {

      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/job-applications/fetch/${id}`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });


      if (response.application.jobId) {

        const endpointForAJobApplicants = `${config.devServer.proxy}/job/${response.application.jobId}`;

        await Api()
          .get(endpointForAJobApplicants)
          .then((res) => {
            response.application['otherApplicants'] = res.data.data.applications;
          })
          .catch((err) => {
            error = err.response.data;
          });
      }

      return { response, error };

    },
    async getAllApplications(context) {

      let response; let error;

      const endpoint = `${config.devServer.proxy}/application/all`;

      await Api()
        .get(endpoint)
        .then((res) => {
          response = res.data.data;
          context.commit('allApplications', response);

        })
        .catch((err) => {
          error = err;
        });

      return { response, error };

    },
    async fetchAUser(context, data) {
      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/fetch/${data}`;

      await Api().
        get(endpoint)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async applyToJob(context, data) {

      let response;
      let error;
      let {
        firstResponse,
        secondResponse,
        thirdResponse,
        selectedCV,
        selectedVideo
      } = data[0];

      if (typeof (selectedCV) === 'object') {

        const fd = new FormData;
        fd.append('user-file', selectedCV, selectedCV.name);
        const endpoint = `${config.devServer.proxy}/job/upload-cv`;

        await Api().
          post(endpoint, fd)
          .then((res) => {
            selectedCV = res.data.cvData.secure_url;
          })
          .catch((err) => {
            error = err.response ? err.response.data : err;
          });
      }

      if (selectedVideo !== null && typeof (selectedVideo) === 'object') {

        const fd = new FormData;
        fd.append('user-video', selectedVideo, selectedVideo.name);
        const endpoint = `${config.devServer.proxy}/job/upload-video`;

        await Api().
          post(endpoint, fd)
          .then((res) => {
            selectedVideo = res.data.videoData.secure_url;
          })
          .catch((err) => {
            error = err.response ? err.response.data : err;
          });

      }

      if (typeof (selectedVideo) === 'string' || typeof (selectedCV) === 'string') {

        let expectedObject = {
          cvUrl: selectedCV !== null ? selectedCV : '',
          videoUrl: selectedVideo !== null ? selectedVideo : '',
        };
        firstResponse? expectedObject['firstResponse'] = firstResponse : null;
        secondResponse? expectedObject['secondResponse'] = secondResponse : null;
        thirdResponse? expectedObject['thirdResponse'] = thirdResponse : null;

        const endpoint = `${config.devServer.proxy}/job/${data[1]}/apply`;

        await Api().
          post(endpoint, { ...expectedObject })
          .then((res) => {
            context.commit('updateMyApplications', res.data);
            response = res.data;
          })
          .catch((err) => {
            error = err.response ? err.response.data : err;
          });
      }

      return { response, error };

    },
    async reviewApplication(context, data) {

      let response; let error;
      let expectedComment;

      const endpoint = `${config.devServer.proxy}/job/${data.id}/review`;

      if (data.status === 'declined') {
        expectedComment = { declineComment: data.reviewComment };
      } else if (data.status === 'shortlisted') {
        expectedComment = { shortlistComment: data.reviewComment };
      } else if (data.status === 'scheduled-for-interview') {
        expectedComment = { ...data.reviewComment };
      } else if (data.status === 'hired') {
        expectedComment = { hireComment: data.reviewComment };
      }

      await Api().
        patch(endpoint, { status: data.status, ...expectedComment })
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data;
        });

      return { response, error };

    },
    async updateProfile(context, data) {

      // Define data received
      let userType = data[2];
      let id = data[3];

      let response;
      let error;
      let expectedBody = {};

      // Define the profile update API endpoint depending on the kind of user:
      // (Admin/Business/Applicant - has attribute 'userType') or
      // Agency - does not have attribute 'userType'
      let endpoint;

      userType ?
      endpoint = `${config.devServer.proxy}/user/edit`
      : endpoint = `${config.devServer.proxy}/agency/edit/${id}`;

      Object.keys(data[0]).forEach((field) => {
        if(data[0][`${field}`] && data[0][`${field}`].length){

          if(field === 'companyContactPerson') {
            expectedBody['firstName'] = data[0][`${field}`].split(' ')[0];
            expectedBody['lastName'] = data[0][`${field}`].split(' ')[1];
          }

          else if(field === 'employees') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody['businessSize'] = data[0][`${field}`];
            } else {
              expectedBody['employeeStrength'] = data[0][`${field}`];
            }
          }

          else if (field === 'companyName') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody[field] = data[0][`${field}`];
            } else {
              expectedBody['agencyName'] = data[0][`${field}`];
            }
          }

          else if (field === 'companyEmail') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody[field] = data[0][`${field}`];
            } else {
              expectedBody['agencyEmail'] = data[0][`${field}`];
            }
          }

          else if (field === 'companyContactPersonPhone') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody['phone'] = data[0][`${field}`];
            } else {
              expectedBody['phone'] = data[0][`${field}`];
            }
          }

          else if (field === 'companyAddress') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody['businessAddress'] = data[0][`${field}`];
            } else {
              expectedBody['agencyAddress'] = data[0][`${field}`];
            }
          }

          else if (field === 'companyPhone') {
            if(userType === 'admin' || userType === 'business') {
              expectedBody['businessRepPhone'] = data[0][`${field}`];
            } else {
              expectedBody['agencyPhone'] = data[0][`${field}`];
            }
          }

          else if (field === 'industry') {
            if (userType === 'admin' || userType === 'business') {
              expectedBody['businessType'] = data[0][`${field}`];
            } else {
              expectedBody['industry'] = data[0][`${field}`];
            }
          }

          else {
            expectedBody[field] = data[0][`${field}`];
          }
        }
      });

      // If profile update is by an applicant and a CV file exist
      let selectedCv = data[0].selectedCvFile;
      if (selectedCv) {
        const fd = new FormData;
        fd.append('user-file', selectedCv, selectedCv.name);

        const cvUploadEndpoint = `${config.devServer.proxy}/job/upload-cv`;

        await Api().
          post(cvUploadEndpoint, fd)
          .then(() => {
            response = 'CV successfully uploaded';
          })
          .catch((err) => {
            error = err;
          });
      }

      // If profile update is by an applicant and a Video file exist
      let selectedVideo = data[0].selectedVideoFile;
      if (selectedVideo) {

        const fd = new FormData;
        fd.append('user-video', selectedVideo, selectedVideo.name);

        const videoUploadEndpoint = `${config.devServer.proxy}/job/upload-video`;

        await Api().
          post(videoUploadEndpoint, fd)
          .then(() => {
            response = 'Video file successfully uploaded';
          })
          .catch((err) => {
            error = err;
          });
      }

      // Finally, update user data if formData is not empty
      if(Object.keys(expectedBody).length !== 0) {

        await Api().
        patch(endpoint, expectedBody)
        .then((res) => {
          response = res.data.message;
          context.commit('updatedUserData', response.data.user);
        })
        .catch((err) => {
          error = err.response;
        });
      }

      return { response, error };

    },
    async profileUpload(context, data) {
      let response;
      let error;

      if(typeof(data) === 'object') {
        const fd = new FormData;
        fd.append('user-file', data, data.name);

        const endpoint = `${config.devServer.proxy}/user/profile-pic/upload`;

        await Api().
          patch(endpoint, fd)
          .then((res) => {
            context.commit('updatedUserData', res.data.user);
            response = res.data.message;
          })
          .catch((err) => {
            error = err;
          });
      }

      return { response, error };

    },
    async changePassword(context, data){
      let response; let error;

      const endpoint = `${config.devServer.proxy}/user/change-password`;

      await Api()
        .post(endpoint, data)
        .then((res) => {
          response = res.data;
        })
        .catch((err) => {
          error = err.response.data.error;
        });

      return { response, error };

    }
  }
  // End of Actions
});
